$(document).ready(function(){
  if($("body").hasClass("chestguardredirect")){
    window.location.href='/';
  }
})
$(document).ready(function(){
  var numAdd = 3
  var dataAvui = new Date()
  for (var i=0;i<=numAdd;i++)
  { 
    var dataTemp = dataAvui
    //console.dir(dataTemp.toString())
    dataTemp.setDate(dataTemp.getDate() + 1)
    if(dataTemp.getDay() == 6){
      dataTemp.setDate(dataTemp.getDate() + 2)
    }else if(dataTemp.getDay() == 0){
      dataTemp.setDate(dataTemp.getDate() + 1)
    }

    dataAvui = dataTemp
  }


  var weekday = new Array(7);
  weekday[0] =  "Sunday";
  weekday[1] = "Monday";
  weekday[2] = "Tuesday";
  weekday[3] = "Wednesday";
  weekday[4] = "Thursday";
  weekday[5] = "Friday";
  weekday[6] = "Saturday";

  var month = new Array();
  month[0] = "Jan.";
  month[1] = "Feb.";
  month[2] = "Mar.";
  month[3] = "Apr.";
  month[4] = "May.";
  month[5] = "Jun.";
  month[6] = "Jul.";
  month[7] = "Aug.";
  month[8] = "Sept.";
  month[9] = "Oct.";
  month[10] = "Nov.";
  month[11] = "Dec.";


  var getday = weekday[dataAvui.getDay()];
  var getdate = dataAvui.getDate();
  var getmonth = month[dataAvui.getMonth()];
  var getyear = dataAvui.getYear();
  if(getyear == 117){getyear = 17}
  var startingdate = getday+" "+getmonth+" "+getdate;
  //console.log("startingdate=="+startingdate);


  var numAdd = 5
  var dataAvui = new Date()
  for (var i=0;i<=numAdd;i++)
  { 
    var dataTemp = dataAvui
    //console.dir(dataTemp.toString())
    dataTemp.setDate(dataTemp.getDate() + 1)
    if(dataTemp.getDay() == 6){
      dataTemp.setDate(dataTemp.getDate() + 2)
    }else if(dataTemp.getDay() == 0){
      dataTemp.setDate(dataTemp.getDate() + 1)
    }

    dataAvui = dataTemp
  }


  var weekday = new Array(7);
  weekday[0] =  "Sunday";
  weekday[1] = "Monday";
  weekday[2] = "Tuesday";
  weekday[3] = "Wednesday";
  weekday[4] = "Thursday";
  weekday[5] = "Friday";
  weekday[6] = "Saturday";

  var month = new Array();
  month[0] = "Jan.";
  month[1] = "Feb.";
  month[2] = "Mar.";
  month[3] = "Apr.";
  month[4] = "May.";
  month[5] = "Jun.";
  month[6] = "Jul.";
  month[7] = "Aug.";
  month[8] = "Sept.";
  month[9] = "Oct.";
  month[10] = "Nov.";
  month[11] = "Dec.";


  var getday = weekday[dataAvui.getDay()];
  var getdate = dataAvui.getDate();
  var getmonth = month[dataAvui.getMonth()];
  var getyear = dataAvui.getYear();
  if(getyear == 117){getyear = 17}
  var endingdate = getday+" "+getmonth+" "+getdate;
 // console.log("endingdate=="+startingdate+" to "+endingdate);
  $(".estdelvry span").html(startingdate+" to "+endingdate);


  $(window).resize(function(){
    if ($(window).width() < 480) {
      $('.desktop--cart').insertAfter('#cart_form');
    }
    else {
      $('.desktop--cart').insertAfter('#cart_form .section.clearfix');
    }
  });

  if ($(window).width() < 480) {
    $('.desktop--cart').insertAfter('#cart_form');
  }
  else {
    $('.desktop--cart').insertAfter('#cart_form .section.clearfix');
  }


  //   For first variant normal products
  var element = $(".select > select.single-option-selector").find('option:selected'); 
  var element = $(this).find('option:selected'); 
  var myTag = element.attr("data-inventory");
  var barcode = element.attr("data-barcode");
  var getsku = element.attr("data-sku");
  myTag = parseInt(myTag);
  var getavail = element.attr("data-availability");
  if(getavail == 'true') {
    $(".quick_left").css("display","inline-block");
    if(myTag >= 1 && myTag <= 10){
      $(".quick_left > span").html("1");
    }
    if(myTag >= 11 && myTag <= 20){
      $(".quick_left > span").html("2");
    }
    if(myTag >= 21 && myTag <= 30){
      $(".quick_left > span").html("3");
    }
    if(myTag >= 31 && myTag <= 40){
      $(".quick_left > span").html("4");
    }
    if(myTag >= 41 && myTag <= 50){
      $(".quick_left > span").html("5");
    }
    if(myTag >= 51 && myTag <= 60){
      $(".quick_left > span").html("6");
    }
    if(myTag >= 61 && myTag <= 70){
      $(".quick_left > span").html("7");
    }
    if(myTag >= 71 && myTag <= 80){
      $(".quick_left > span").html("8");
    }
    if(myTag >= 81 && myTag <= 90){
      $(".quick_left > span").html("9");
    }
    if(myTag >= 91){
      $(".quick_left > span").html("10");
    }
  }
  else{
    $(".quick_left").hide();
  }

  //   if(getsku == 'BST01' || getsku == 'BST04' || getsku == 'BST03' || getsku == 'BAR01' || getsku == 'BAR02' || getsku == 'BAR03' ||getsku == 'BAR04' || getsku == 'BAR05' || getsku == 'BAR06' || getsku == 'BAR07' || getsku == 'CSU03B' || getsku == 'CSU07B' || getsku == 'CSU05B' || getsku == 'CSU04B' || getsku == 'CSU96B' || getsku == 'CSU95B' || getsku == 'CSU97B' || getsku == 'CWL04' || getsku == 'CWL01' || getsku == 'CWL03' || getsku == 'CAL03' || getsku == 'CAL07' || getsku == 'CAL05' || getsku == 'CAL04' || getsku == 'CAL97' || getsku == 'CAL98' || getsku == 'CCR99' || getsku == 'CMH99' || getsku == 'CBA01' || getsku == 'CBA02' || getsku == 'AEV01A' || getsku == 'AEV01B' || getsku == 'TEV01A' || getsku == 'TEV01B' || getsku == 'AEV01B' || getsku == 'AEV01A' || getsku == 'QGR03' || getsku == 'QGR04' || getsku == 'QSU01' || getsku == 'TT06'){
  //       $(".estdelvry span").html("SHIPPING EMS TRANSIT 8 TO 10 DAYS");
  //     }
  //     else
  //     {
  //       $(".estdelvry span").html(startingdate+" to "+endingdate);
  //     }

  $(".estdelvry span").html(startingdate+" to "+endingdate);

  if(getsku == 'CWL03' || getsku == 'CWL01' || getsku == 'CWL04' || getsku == 'CAL03' || getsku == 'CAL07' || getsku == 'CAL05' || getsku == 'CAL04' || getsku == 'CAL97' || getsku == 'CAL98' || getsku == 'CCR99' || getsku == 'CMH99' || getsku == 'BAR03' || getsku == 'BAR01' || getsku == 'BAR04' || getsku == 'BAR07' || getsku == 'BAR05' || getsku == 'BAR06' || getsku == 'CSU07B' || getsku == 'CSU05B' || getsku == 'CSU03B' || getsku == 'CSU04B' || getsku == 'CSU96B' || getsku == 'CSU95B' || getsku == 'CSU97B' || getsku == 'BST03' || getsku == 'BCM01' || getsku == 'BST01' || getsku == 'BST04' || getsku == 'BPC01' || getsku == 'BPC03' || getsku == 'BPC06' || getsku == 'BPC04' || getsku == 'TEV01B' || getsku == 'TEV08B' || getsku == 'TEV01A' || getsku == 'TEV08A' || getsku == 'AEV01A' || getsku == 'AEV01B' || getsku == 'CBA01' || getsku == 'CBA02' || getsku == 'QGR04' || getsku == 'QGR03' || getsku == 'QGR01' || getsku == 'QSU01' || getsku == 'QSU08' || getsku == 'QSU06' || getsku == 'QCH09' || getsku == 'QCH08' || getsku == 'TT06' || getsku == 'TT03'){
    if(myTag <= 0){
      //       $(".addtocartdiv").show();
      //       $(".preorderdiv").hide();
      //       $(".estdelvry span").html("Monday Sept. 25");
      //       $("button.addtocartdiv.btn.btn-default.buy_now").html("<i class='fa fa-shopping-cart'></i> Pre Order");
      //       $(".estdelvry").addClass("addbordere");
    }
    else{
      $(".estdelvry span").html(startingdate+" to "+endingdate);
      $("button.addtocartdiv.btn.btn-default.buy_now").html("<i class='fa fa-shopping-cart'></i> Add to cart");
      $(".addbordere").removeClass("addbordere");
    }
  }

  //   For first variant Pre order products
  var element = $(".variantarea .select select.ttt.single-option-selector").find('option:selected'); 
  var element = $(this).find('option:selected'); 
  var myTag = element.attr("data-inventory");
  var barcode = element.attr("data-barcode");
  var getsku = element.attr("data-sku");
  myTag = parseInt(myTag);
  if(getsku == 'CWL03' || getsku == 'CWL01' || getsku == 'CWL04' || getsku == 'CAL03' || getsku == 'CAL07' || getsku == 'CAL05' || getsku == 'CAL04' || getsku == 'CAL97' || getsku == 'CAL98' || getsku == 'CCR99' || getsku == 'CMH99' || getsku == 'BAR03' || getsku == 'BAR01' || getsku == 'BAR04' || getsku == 'BAR07' || getsku == 'BAR05' || getsku == 'BAR06' || getsku == 'CSU07B' || getsku == 'CSU05B' || getsku == 'CSU03B' || getsku == 'CSU04B' || getsku == 'CSU96B' || getsku == 'CSU95B' || getsku == 'CSU97B' || getsku == 'BST03' || getsku == 'BCM01' || getsku == 'BST01' || getsku == 'BST04' || getsku == 'BPC01' || getsku == 'BPC03' || getsku == 'BPC06' || getsku == 'BPC04' || getsku == 'TEV01B' || getsku == 'TEV08B' || getsku == 'TEV01A' || getsku == 'TEV08A' || getsku == 'AEV01A' || getsku == 'AEV01B' || getsku == 'CBA01' || getsku == 'CBA02' || getsku == 'QGR04' || getsku == 'QGR03' || getsku == 'QGR01' || getsku == 'QSU01' || getsku == 'QSU08' || getsku == 'QSU06' || getsku == 'QCH09' || getsku == 'QCH08' || getsku == 'TT06' || getsku == 'TT03'){
    if(myTag <= 0){
      //       $(".addtocartdiv").show();
      //       $(".preorderdiv").hide();
      //       $(".estdelvry span").html("Monday Sept. 25");
      //       $("button.addtocartdiv.btn.btn-default.buy_now").html("<i class='fa fa-shopping-cart'></i> Pre Order");
      //       $(".estdelvry").addClass("addbordere");
    }
    else{
      $(".estdelvry span").html(startingdate+" to "+endingdate);
      $("button.addtocartdiv.btn.btn-default.buy_now").html("<i class='fa fa-shopping-cart'></i> Add to cart");
      $(".addbordere").removeClass("addbordere");
    }
  }
  $(".estdelvry.makedatepreorder.thisisapreorder span").html("Monday Sept. 25");

  var getskuforsingle = $(".signlevariant").attr("data-sku");
  //   if(getskuforsingle == 'BST01' || getskuforsingle == 'BST04' || getskuforsingle == 'BST03' || getskuforsingle == 'BAR01' || getskuforsingle == 'BAR02' || getskuforsingle == 'BAR03' ||getskuforsingle == 'BAR04' || getskuforsingle == 'BAR05' || getskuforsingle == 'BAR06' || getskuforsingle == 'BAR07' || getskuforsingle == 'CSU03B' || getskuforsingle == 'CSU07B' || getskuforsingle == 'CSU05B' || getskuforsingle == 'CSU04B' || getskuforsingle == 'CSU96B' || getskuforsingle == 'CSU95B' || getskuforsingle == 'CSU97B' || getskuforsingle == 'CWL04' || getskuforsingle == 'CWL01' || getskuforsingle == 'CWL03' || getskuforsingle == 'CAL03' || getskuforsingle == 'CAL07' || getskuforsingle == 'CAL05' || getskuforsingle == 'CAL04' || getskuforsingle == 'CAL97' || getskuforsingle == 'CAL98' || getskuforsingle == 'CCR99' || getskuforsingle == 'CMH99' || getskuforsingle == 'CBA01' || getskuforsingle == 'CBA02' || getskuforsingle == 'AEV01A' || getskuforsingle == 'AEV01B' || getskuforsingle == 'TEV01A' || getskuforsingle == 'TEV01B' || getskuforsingle == 'AEV01B' || getskuforsingle == 'AEV01A' || getskuforsingle == 'QGR03' || getskuforsingle == 'QGR04' || getskuforsingle == 'QSU01' || getskuforsingle == 'TT06'){
  //     $(".estdelvry span").html("SHIPPING EMS TRANSIT 8 TO 10 DAYS");
  //   }

  $('.select > select.single-option-selector').on('change', function() {
    var element = $(this).find('option:selected'); 
    var myTag = element.attr("data-inventory");
    var barcode = element.attr("data-barcode");
    var getsku = element.attr("data-sku");
    var getavail = element.attr("data-availability");
    
    myTag = parseInt(myTag);

    if(getavail == 'true') {
      $(".quick_left").css("display","inline-block");
      if(myTag >= 1 && myTag <= 10){
        $(".quick_left > span").html("1");
      }
      if(myTag >= 11 && myTag <= 20){
        $(".quick_left > span").html("2");
      }
      if(myTag >= 21 && myTag <= 30){
        $(".quick_left > span").html("3");
      }
      if(myTag >= 31 && myTag <= 40){
        $(".quick_left > span").html("4");
      }
      if(myTag >= 41 && myTag <= 50){
        $(".quick_left > span").html("5");
      }
      if(myTag >= 51 && myTag <= 60){
        $(".quick_left > span").html("6");
      }
      if(myTag >= 61 && myTag <= 70){
        $(".quick_left > span").html("7");
      }
      if(myTag >= 71 && myTag <= 80){
        $(".quick_left > span").html("8");
      }
      if(myTag >= 81 && myTag <= 90){
        $(".quick_left > span").html("9");
      }
      if(myTag >= 91){
        $(".quick_left > span").html("10");
      }
    }
    else{
      $(".quick_left").hide();
    }

    if(getavail == 'false') {
      if(myTag <= 0){
        $(".addtocartdiv").hide();
        $(".preorderdiv").show();
        $(".action_button.quickcheckout").html("Out Of Stock");
        $(".action_button.quickcheckout").attr("disabled", "disabled");
        $(".action_button.quickcheckout").addClass("disablethis");
        $(".out_of_Stock_notify").addClass("show_this");
      }
      else{
        $(".addtocartdiv").show();
        $(".preorderdiv").hide();
        $(".action_button.quickcheckout").html("Quick Checkout");
        $(".action_button.quickcheckout").removeAttr("disabled");
        $(".disablethis").removeClass("disablethis");
        $(".out_of_Stock_notify").removeClass("show_this");
      }
    }
    else{
      $(".addtocartdiv").show();
      $(".preorderdiv").hide();
      $(".action_button.quickcheckout").html("Quick Checkout");
      $(".action_button.quickcheckout").removeAttr("disabled");
      $(".disablethis").removeClass("disablethis");
      $(".out_of_Stock_notify").removeClass("show_this");
    }

    //     if(getsku == 'BST01' || getsku == 'BST04' || getsku == 'BST03' || getsku == 'BAR01' || getsku == 'BAR02' || getsku == 'BAR03' ||getsku == 'BAR04' || getsku == 'BAR05' || getsku == 'BAR06' || getsku == 'BAR07' || getsku == 'CSU03B' || getsku == 'CSU07B' || getsku == 'CSU05B' || getsku == 'CSU04B' || getsku == 'CSU96B' || getsku == 'CSU95B' || getsku == 'CSU97B' || getsku == 'CWL04' || getsku == 'CWL01' || getsku == 'CWL03' || getsku == 'CAL03' || getsku == 'CAL07' || getsku == 'CAL05' || getsku == 'CAL04' || getsku == 'CAL97' || getsku == 'CAL98' || getsku == 'CCR99' || getsku == 'CMH99' || getsku == 'CBA01' || getsku == 'CBA02' || getsku == 'AEV01A' || getsku == 'AEV01B' || getsku == 'TEV01A' || getsku == 'TEV01B' || getsku == 'AEV01B' || getsku == 'AEV01A' || getsku == 'QGR03' || getsku == 'QGR04' || getsku == 'QSU01' || getsku == 'TT06'){
    //       $(".estdelvry span").html("SHIPPING EMS TRANSIT 8 TO 10 DAYS");
    //     }
    //     else
    //     {
    //       $(".estdelvry span").html(startingdate+" to "+endingdate);
    //     }
    $(".estdelvry span").html(startingdate+" to "+endingdate);

    if(getsku == 'CWL03' || getsku == 'CWL01' || getsku == 'CWL04' || getsku == 'CAL03' || getsku == 'CAL07' || getsku == 'CAL05' || getsku == 'CAL04' || getsku == 'CAL97' || getsku == 'CAL98' || getsku == 'CCR99' || getsku == 'CMH99' || getsku == 'BAR03' || getsku == 'BAR01' || getsku == 'BAR04' || getsku == 'BAR07' || getsku == 'BAR05' || getsku == 'BAR06' || getsku == 'CSU07B' || getsku == 'CSU05B' || getsku == 'CSU03B' || getsku == 'CSU04B' || getsku == 'CSU96B' || getsku == 'CSU95B' || getsku == 'CSU97B' || getsku == 'BST03' || getsku == 'BCM01' || getsku == 'BST01' || getsku == 'BST04' || getsku == 'BPC01' || getsku == 'BPC03' || getsku == 'BPC06' || getsku == 'BPC04' || getsku == 'TEV01B' || getsku == 'TEV08B' || getsku == 'TEV01A' || getsku == 'TEV08A' || getsku == 'AEV01A' || getsku == 'AEV01B' || getsku == 'CBA01' || getsku == 'CBA02' || getsku == 'QGR04' || getsku == 'QGR03' || getsku == 'QGR01' || getsku == 'QSU01' || getsku == 'QSU08' || getsku == 'QSU06' || getsku == 'QCH09' || getsku == 'QCH08' || getsku == 'TT06' || getsku == 'TT03'){
      $(".estdelvry").show();
      if(myTag <= 0){
        //         $(".addtocartdiv").show();
        //         $(".preorderdiv").hide();
        //         $(".estdelvry span").html("Monday Sept. 25");
        //         $("button.addtocartdiv.btn.btn-default.buy_now").html("<i class='fa fa-shopping-cart'></i> Pre Order");
        //         $(".estdelvry").addClass("addbordere");
        //         console.log("check3");
      }
      else{
        $(".estdelvry span").html(startingdate+" to "+endingdate);
        $("button.addtocartdiv.btn.btn-default.buy_now").html("<i class='fa fa-shopping-cart'></i> Add to cart");
        $(".addbordere").removeClass("addbordere");
      }
    }
    else{
      if(myTag <= 0){
       // console.log("check");
        //$(".estdelvry").hide();
      }
      else{
       // console.log("check1");
        $(".estdelvry").show();
      }
    }
    var getprice = element.attr("data-price");
    $("span.product_price.money.mobilehide.test123").html(getprice);
    $(".var-barcode").html("UPC: "+barcode);
  });



  var checkkkk = 0;
  $('.select > select.single-option-selector option').each(function() {
    var getinvent = $(this).attr("data-inventory"); 
    getinvent = parseInt(getinvent);
    // console.log("getinvent="+getinvent);
    if(checkkkk == 0){
      if(getinvent > 0){
        checkkkk = 1;
        $(this).attr("selected","selected").trigger("change");
      }

    }
  })

  $('.colselect').on('change', function() {
    var element = $(this).find('option:selected'); 
    var myTag = element.attr("data-inventory");
    var proidd = element.attr("data-proid");
    myTag = parseInt(myTag);
   // console.log("myTag=="+myTag);
    if(myTag < 0){
      //  $(this).parents(".select").siblings(".preorder").hide();
      // $(this).parents(".select").siblings(".addtocartd").show();
      $(".preorder-"+proidd).show();
      $(".addtocartd-"+proidd).hide();
    }
    else{
      $(".addtocartd-"+proidd).show();
      $(".preorder-"+proidd).hide();
    }
  });

  //   Show pre order on collection pages
  $("body.collection .product_form .select > select, body.index .product_form .select > select").on('change', function() {
    var getselectedsrcimagevarid = $(this).find(":selected").attr("data-vargetimgid") ;
    var getsrcimgg = $("."+getselectedsrcimagevarid).attr("src");
    //$(this).parents(".collectionProduct")
    var getselectedsrcimage = $(this).find(":selected").attr("data-imagesrc") ;
    var getselectedsrcimageid = $(this).find(":selected").attr("data-getimgid") ;
    if( getsrcimgg.indexOf( "no-image-" ) != -1 ){}
    else{
      $("#"+getselectedsrcimageid).attr("src",getsrcimgg);
    }



    var getselectedinventory = $(this).find(":selected").attr("data-inventory") ;
    var getselectedsku = $(this).find(":selected").attr("data-sku") ;
    if(getselectedsku == 'CWL03' || getselectedsku == 'CWL01' || getselectedsku == 'CWL04' || getselectedsku == 'CAL03' || getselectedsku == 'CAL07' || getselectedsku == 'CAL05' || getselectedsku == 'CAL04' || getselectedsku == 'CAL97' || getselectedsku == 'CAL98' || getselectedsku == 'CCR99' || getselectedsku == 'CMH99' || getselectedsku == 'BAR03' || getselectedsku == 'BAR01' || getselectedsku == 'BAR04' || getselectedsku == 'BAR07' || getselectedsku == 'BAR05' || getselectedsku == 'BAR06' || getselectedsku == 'CSU07B' || getselectedsku == 'CSU05B' || getselectedsku == 'CSU03B' || getselectedsku == 'CSU04B' || getselectedsku == 'CSU96B' || getselectedsku == 'CSU95B' || getselectedsku == 'CSU97B' || getselectedsku == 'BST03' || getselectedsku == 'BCM01' || getselectedsku == 'BST01' || getselectedsku == 'BST04' || getselectedsku == 'BPC01' || getselectedsku == 'BPC03' || getselectedsku == 'BPC06' || getselectedsku == 'BPC04' || getselectedsku == 'TEV01B' || getselectedsku == 'TEV08B' || getselectedsku == 'TEV01A' || getselectedsku == 'TEV08A' || getselectedsku == 'AEV01A' || getselectedsku == 'AEV01B' || getselectedsku == 'CBA01' || getselectedsku == 'CBA02' || getselectedsku == 'QGR04' || getselectedsku == 'QGR03' || getselectedsku == 'QGR01' || getselectedsku == 'QSU01' || getselectedsku == 'QSU08' || getselectedsku == 'QSU06' || getselectedsku == 'QCH09' || getselectedsku == 'QCH08' || getselectedsku == 'TT06')
    {
      if(getselectedinventory < 1){
        //         $( "<span class='sku-"+getselectedsku+"-test availableInfo'>This product will ship on Sept. 25.</span>" ).insertBefore( $(this).parent('.select').siblings('.purchase').children('.action_button.add_to_cart') );
        //       $(this).parent(".select").siblings(".purchase").children(".action_button.add_to_cart").children("span").html("Pre-Order");
        //         $(this).parent(".select").siblings(".purchase").children(".action_button.preorder").html("Pre-Order");
      }

      else{
        $(this).parent(".select").siblings(".purchase").children(".availableInfo").remove();
        $(this).parent(".select").siblings(".purchase").children(".action_button.add_to_cart").children("span").html("Add to cart");
        $(this).parent(".select").siblings(".purchase").children(".action_button.preorder").html("Add to cart");
      }
    }
   // console.log("inventory=="+getselectedinventory);
  })
  $(".onhover").click(function(){
    $(this).children(".hoverbox").show();
    $(this).children(".hoverbox").addClass("showfornow");
    setTimeout(function(){ 
      $(".showfornow").hide();
      $(".showfornow").removeClass("showfornow");
    }, 2000);
  })
})

$(document).ready(function(){
  $(".overlaydiv, .closeimage > img").click(function(){
    $(".overlaydiv, .popupdiv").fadeOut();
  })
  $("body.product section.product_detail #carousel > .carousel-inner img").click(function(){

    var getsrc = $(this).attr("src");
    $(".imgsrc").attr("src",getsrc);
    $(".overlaydiv, .popupdiv").fadeIn();

  })

  $("body.index .blow_banner_main .blow_banner_product").click(function(){

    var gethrf = $(this).children(".banner_product_text").children("a").attr("href");
   // console.log("ttt=="+gethrf);
    window.location.href='https://legendarchery.com'+gethrf;
  })
})

$(document).ready(function(){
  $(".quickcheckout").click(function(){
    var form = $(".thisform");

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      async: false,
      data: form.serialize(),
      dataType: 'json',
      error: function(){
        alert("Something went wrong! Please try again by refreshing the page");
      },
      success: function(){
        window.location.href='/checkout';
      },
      cache: false
    });
  })

  $(".topform #quantity.quantity").keyup(function(){
    var getvalu = $(this).val();
    $("form.thisform #quantity.qty").val(getvalu);
  })
})

function toggleQ(faqDIVid){
  var d = document.getElementById(faqDIVid);
  if(d){
    d.className=='questionClosed ezfaq_answers'?d.className='questionOpen ezfaq_answers':d.className='questionClosed ezfaq_answers';
  }
}

$(document).ready(function(){
  $("#slide-1 .bcg").click(function(){
    window.location.href='/pages/black-friday-deals';
  })
})

$(document).ready(function() {
//   $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
//     if ($('#agree').is(':checked')) {
//       $(this).submit();
//     }
//     else {
//       alert("You must agree with the terms and conditions of sales to check out.");
//       return false;
//     }
//   });


  var z =1 ;
  $('.mobile_nav #nav > ul:first-of-type li ul').each(function(){

    var mobile_submenu= $(this).html();
    $(this).siblings('span.more_btn').attr('ul-no', z);
    $(this).remove();

    $('#mobile__nav.mobile_nav #nav').append('<ul class="sub_menu" id="sub_menu_'+z+'">'+mobile_submenu+'</ul>')

    z++;

  });


  $('#nav ul li .more_btn').click(function(){
   // console.log('you click here');
    var ul_no = $(this).attr('ul-no');

    $('#sub_menu_'+ul_no).addClass('submenu_is_open');

    $(this).parents('ul').addClass('ul_submenu_is_open');

  });

  $('#nav ul.sub_menu .back_btn a').click(function(){ 
    $('#nav ul').removeClass('ul_submenu_is_open');
    $('#nav ul.sub_menu').removeClass('submenu_is_open');

  });

  $('#mob_nav').click(function(){ 
    $('#mobile__nav').toggleClass('mob_menu_main_open');
    $('#mobile__menu_overlay').toggleClass('mobile__menu_overlay_close');

  });

  $('#mobile__menu_overlay').click(function(){ 
    $('#mobile__nav').removeClass('mob_menu_main_open');
    $('#mobile__menu_overlay').removeClass('mobile__menu_overlay_close');

  });


});


// $(window).resize(function(){
//   var product_slider__height= $('#carousel.product_banner .item').innerHeight();
//         console.log('resize: '+ product_slider__height);
//   $('#carousel.product_banner .item').css('height', product_slider__height+'px')
// });


// $(document).ready(function(){
//   var product_slider__height= $('#carousel.product_banner .item').innerHeight();
//   $('#carousel.product_banner .item').css('height', product_slider__height+'px')
// });



function mobileSlider(){
  var slider_len = $("#owl-main_slider1 .owl-wrapper-outer").length;
  if(slider_len == 0 || typeof slider_len == 'undefined')
  {
    setTimeout(function(){
      mobileSlider();
    },1000)
  }
  else
  {
    var mob_slider= $(' .product_detail .pm_slider').innerHeight();

    $('body.product .container.main.content .container').css({'top': mob_slider+'px', 'margin-bottom':mob_slider+'px'})
  }
}





setTimeout(function(){
  var mob_slider_1= $(' .product_detail .pm_slider').innerHeight();

  $('body.product .container.main.content .container').css({'top': mob_slider_1+'px', 'margin-bottom':mob_slider_1+'px'})
}, 1000);

setTimeout(function(){
  var mob_slider_1= $(' .product_detail .pm_slider').innerHeight();

  $('body.product .container.main.content .container').css({'top': mob_slider_1+'px', 'margin-bottom':mob_slider_1+'px'})
}, 1500);


if ( $(window).width() <= 766  ) { 
  setTimeout(function(){
    var mob_slider= $(' .product_detail .pm_slider').innerHeight();
    $('body.product .container.main.content .container').css({'top': mob_slider+'px', 'margin-bottom':mob_slider+'px'})
  }, 1000);
  
  mobileSlider();

}






$(window).resize(function(){
  if ( $(window).width() < 766) { 
    var mob_slider= $(' .product_detail .pm_slider').innerHeight();

    $('body.product .container.main.content .container').css({'top': mob_slider+'px', 'margin-bottom':mob_slider+'px'})
 
  mobileSlider();
  }

  setTimeout(function(){
    if ( $(window).width() < 766) { 
      var mob_slider= $(' .product_detail .pm_slider').innerHeight();

      $('body.product .container.main.content .container').css({'top': mob_slider+'px', 'margin-bottom':mob_slider+'px'})
    }
  }, 500);

});




// mobile menu script

$(document).ready(function(){
  $('.mobile_navbar#sidebar .menu_tab .main_menu').click(function(){
    var tab__index = $(this).attr('tab-index');

    $('.mobile_navbar#sidebar .menu_tab .main_menu ').removeClass('menu_visible');
    $(this).addClass('menu_visible');

    $('.mobile_navbar .tab_menu_list_outer .tab_menu_list').hide();
    $('.mobile_navbar .tab_menu_list_outer .tab_menu_list.tab-menu-active-'+tab__index).show();

  });

  $('#header a.icon-menu-new#mob_nav-new').click(function(){
    $('.mobile_navbar#sidebar').addClass('open_slide');

  });
  
  $('.mobile_navbar#sidebar .overflow_close_anchor').click(function(){
   $('.mobile_navbar#sidebar').removeClass('open_slide');
  });
  
  
  $('body.product .mobile__show__disc_toggle .fabe_body a.toggle_btns#btn_show').click(function(){
  
    $('body.product .mobile__show__disc_toggle').addClass('open');
  
  });
  
    $('body.product .mobile__show__disc_toggle .fabe_body a.toggle_btns#btn_hide').click(function(){
  
    $('body.product .mobile__show__disc_toggle').removeClass('open');
  
  })

});




$(document).ready(function(){
  $(".xsmob_show select").change(function(){
    var currentval = $(this).val();
    $(".xsmob_hidden select").val(currentval);
    $(".xsmob_hidden select").trigger("change");
  })




//     var form = $('#contact_form'),
//         message = $('.contact__msg'),
//         form_data;

//     // Success function
//     function done_func(response) {
//         message.fadeIn()
//         message.html(response);
//         setTimeout(function () {
//             message.fadeOut();
//         }, 5000);
        
//         form.find('input:not([type="submit"]), textarea').val('');
//     }

//     // fail function
//     function fail_func(data) {
//         message.fadeIn()
//         message.html(data.responseText);
//         setTimeout(function () {
//             message.fadeOut(5000);
//         }, 5000);
//     }
    
//     form.submit(function (e) {
//        // e.preventDefault();
//         form_data = $(this).serialize();
//         $.ajax({
//             type: 'POST',
//             url: form.attr('action'),
//             data: form_data
//         })
//         .done(done_func)
//         .fail(fail_func);
//     });
})

$(document).ready(function(){
  $('.select > select.single-option-selector').on('change', function() {
    
    $(".thisform").find(".error").css({"display":"none"});
    
  
  });

});